import { PRODUCT_NAME, TAGLINE } from './brand'

interface WordmarkProps {
  size?: 'sm' | 'lg'
  className?: string
}

// The brand lockup: product name + tagline, always together (CLAUDE.md).
export default function Wordmark({ size = 'sm', className = '' }: WordmarkProps) {
  if (size === 'lg') {
    return (
      <div className={className}>
        <h1 className="font-serif font-semibold tracking-tight text-ob-ink text-[32px] leading-tight md:text-5xl">
          {PRODUCT_NAME}
        </h1>
        <p className="mt-2 font-body text-base text-ob-secondary md:text-lg">{TAGLINE}</p>
      </div>
    )
  }
  return (
    <div className={`leading-none ${className}`}>
      <span className="block font-serif text-lg font-semibold tracking-tight text-ob-ink">
        {PRODUCT_NAME}
      </span>
      <span className="mt-0.5 block font-body text-[10px] tracking-wide text-ob-secondary">
        {TAGLINE}
      </span>
    </div>
  )
}
